module.exports = __webpack_public_path__ + "0b7fb85d18724780ef9000b6316ac4f3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/beach-bungalow-empty.png
// module id = 2805
// module chunks = 0